import { TABLER_CATEGORIES } from '../data/data-provider';
import { rootActions, useAppDispatch, useAppSelector } from '../data/store';

const TablerCategories = () => {

    const dispatch = useAppDispatch();
    const category = useAppSelector(store => store.root.category) || '';

    const changeCategory = (newCategory: string) => {
        dispatch(
            rootActions.setCategory(newCategory)
        )
    };

    return (
        <section className="categories container mx-auto my-8 px-4 text-xs flex flex-wrap justify-center">
            <label
                className={ `mr-4 bg-gray-100 rounded px-3 py-1 block mb-2 cursor-pointer ${ category === '' ? 'selected' : '' }` }
                key={ `tabler-category-radio-all` }>
                <input
                    type="radio"
                    name="tabler-category-radio"
                    className="hidden"
                    checked={ category === '' }
                    onChange={ () => {
                        changeCategory('');
                    }}
                />
                <span>All</span>
            </label>

            {
                TABLER_CATEGORIES.map(categoryName => {
                    return (
                        <label
                            className={ `mr-4 bg-gray-100 rounded px-3 py-1 block mb-2 cursor-pointer ${ category === categoryName ? 'selected' : '' }` }
                            key={ `tabler-category-radio-${ categoryName.toLowerCase() }`}>
                            <input
                                type="radio"
                                name="tabler-category-radio"
                                className="hidden"
                                checked={ category === categoryName }
                                onChange={ () => {
                                    changeCategory(categoryName);
                                }}
                            />
                            <span>{ categoryName }</span>
                        </label>
                    )
                })
            }

            <label
                className={ `mr-4 bg-gray-100 rounded px-3 py-1 block mb-2 cursor-pointer ${ category === 'no-category' ? 'selected' : '' }` }
                key={ `tabler-category-radio-without-category` }>
                <input
                    type="radio"
                    name="tabler-category-radio"
                    className="hidden"
                    checked={ category === 'no-category' }
                    onChange={ () => {
                        changeCategory('no-category');
                    }}
                />
                <span>No category</span>
            </label>
        </section>
    )
};

export default TablerCategories;